import { cn } from '@/lib/utils';
import type { SupplierCandidate } from './types';
import {
  supplierCandidateBank,
  supplierCandidateCategory,
  supplierCandidateCode,
  supplierCandidateId,
  supplierCandidateMatch,
  supplierCandidateName,
  supplierCandidateNtn,
} from './supplierCandidates';

export interface SupplierCandidatePickerProps {
  candidates: SupplierCandidate[];
  selectedId: string;
  onChange: (selected: SupplierCandidate | null) => void;
}

export function SupplierCandidatePicker({
  candidates,
  selectedId,
  onChange,
}: SupplierCandidatePickerProps) {
  return (
    <div className="overflow-x-auto rounded-md border border-neutral-200">
      <table className="w-full text-sm">
        <thead className="bg-neutral-50 text-left text-xs font-medium uppercase tracking-wide text-neutral-600">
          <tr>
            <th className="w-32 px-8 py-6"> </th>
            <th className="px-8 py-6">Code</th>
            <th className="px-8 py-6">Supplier</th>
            <th className="px-8 py-6">NTN</th>
            <th className="px-8 py-6">Category</th>
            <th className="px-8 py-6">Bank account</th>
            <th className="px-8 py-6">Match</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-neutral-100">
          {candidates.map((candidate, index) => {
            const id = supplierCandidateId(candidate);
            const code = supplierCandidateCode(candidate);
            const name = supplierCandidateName(candidate);
            const selected = id !== '' && id === selectedId;
            return (
              <tr key={`${id}-${code}-${index}`} className={cn(selected && 'bg-primary-50')}>
                <td className="px-8 py-6">
                  <input
                    type="radio"
                    name="supplier-candidate"
                    checked={selected}
                    onChange={(e) => onChange(e.target.checked ? candidate : null)}
                    aria-label={`Select supplier ${code || id || name}`}
                  />
                </td>
                <td className="px-8 py-6 font-mono">{code || '-'}</td>
                <td className="px-8 py-6">{name || '-'}</td>
                <td className="px-8 py-6">{supplierCandidateNtn(candidate) || '-'}</td>
                <td className="px-8 py-6">{supplierCandidateCategory(candidate) || '-'}</td>
                <td className="px-8 py-6 font-mono text-xs">
                  {supplierCandidateBank(candidate) || '-'}
                </td>
                <td className="px-8 py-6">{supplierCandidateMatch(candidate) || '-'}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
